module.exports = __webpack_public_path__ + "media/images/user-default-photo-b2c0cf68dce32b5fec90e5748c4cc430.jpg";